export const IS_ONBOARDED = 'isOnboarded';
export const RENEWAL_REMINDER_LAST_SHOWN = 'renewalReminderLastShown';
export const PAYMENT_PROVIDER_CHANGED_SHOWN = 'paymentProviderChangedShown';
